export interface ICalendarDate {
  day: number
  month: number
  year: number
}

export enum ESubscriptionStatus {
  ACTIVE = 'active',
  STALLED = 'stalled',
}

export enum ESubscriptionType {
  WHATSAPP_BASIC = 'whatsapp_basic',
  TARIFF_TRIAL = 'tariff_trial',
  TARIFF_START_FREE = 'tariff_start_free',
  TARIFF_START = 'tariff_start',
  TARIFF_PRO = 'tariff_pro',
}

export enum ESubscriptionFrequency {
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
  THREE_MONTHLY = 'three_monthly',
  SIX_MONTHLY = 'six_monthly',
}

export interface ISubscription {
  id: number;
  type: ESubscriptionType;
  status: ESubscriptionStatus;
  amount: number;
  frequency: ESubscriptionFrequency;
  nextPayment: ICalendarDate;
  lastPayment: ICalendarDate;
  createdAt: Date;
  updatedAt: Date;
  _expiration: Date;
  _active: boolean;
}
